import React from 'react';
import {Modal, Button, Group, Text} from '@mantine/core';

type Props = {
    data?: {
        title: string;
        message: string;
        confirmLabel: string;
        cancelLabel?: string;
        onConfirm: () => void | Promise<void>;
        onCancel?: () => void;
        danger?: boolean;
    };
    close: () => void;
};

export const ConfirmationModal = (props: Props) => {
    const handleConfirm = async () => {
        if (props.data?.onConfirm) {
            await props.data.onConfirm();
        }
        props.close();
    };

    const handleCancel = () => {
        if (props.data?.onCancel) {
            props.data.onCancel();
        }
        props.close();
    };

    return (
        <Modal
            title={props.data?.title || 'Confirm'}
            opened={Boolean(props.data)}
            onClose={handleCancel}
            closeOnClickOutside={false}
            withCloseButton={true}
        >
            {props.data && (
                <>
                    <Text size="sm" mb="lg">
                        {props.data.message}
                    </Text>
                    <Group justify="flex-end">
                        <Button
                            variant="default"
                            onClick={handleCancel}
                        >
                            {props.data.cancelLabel || 'Cancel'}
                        </Button>
                        <Button
                            color={props.data.danger ? 'red' : 'blue'}
                            onClick={handleConfirm}
                        >
                            {props.data.confirmLabel}
                        </Button>
                    </Group>
                </>
            )}
        </Modal>
    );
};